module.exports = __webpack_public_path__ + "img/metro_entrance.14619982.jpg";